import { graphql } from "gatsby"
import React from "react"

import Table from "@atoms/Table/Table"

const CoreTable = ({ thead, tbody, captionHTML, className }) => {
  return <Table caption={captionHTML} head={thead} body={tbody} />
}

export const query = graphql`
  fragment CoreTable on WpBlockCoreTable {
    __typename
    thead
    tbody {
      row
    }
    captionHTML
    className
  }
`

export default CoreTable
